import { render, staticRenderFns } from "./WY-SL-Disclosure.vue?vue&type=template&id=03f7918e&scoped=true&"
import script from "./WY-SL-Disclosure.vue?vue&type=script&lang=js&"
export * from "./WY-SL-Disclosure.vue?vue&type=script&lang=js&"
import style0 from "./WY-SL-Disclosure.vue?vue&type=style&index=0&id=03f7918e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f7918e",
  null
  
)

export default component.exports